import { FC } from 'react';

interface Props {
  SVGIcon: FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  subtitle: string;
}

const FeatureCard: FC<Props> = ({ SVGIcon, title, subtitle }) => {
  return (
    <div className='flex flex-col items-center text-center gap-4'>
      <div className='text-[#0a1f44]'>
        <SVGIcon />
      </div>
      <h3 className="text-3xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 text-sm">
        {subtitle}
      </p>
    </div>
  );
};

export default FeatureCard;
